const roundToPrecision = (subject, precision) => +(+subject).toFixed(precision);

export default roundToPrecision;
